// src/components/provider/SimpleSendMessageBox.jsx
import React, { useState } from "react";
import { sendMessage } from "../APIs/messageService";

export default function MessagesPanel({ providerId, patientId }) {
  const [content, setContent] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [ok, setOk] = useState("");

  const onSend = async (e) => {
    e.preventDefault();
    if (!content.trim()) return;
    setBusy(true);
    setErr("");
    setOk("");
    try {
      await sendMessage({
        senderProviderId: providerId,
        recipientPatientId: patientId,
        content: content.trim(),
      });
      setContent("");
      setOk("Message sent.");
      setTimeout(() => setOk(""), 2000);
    } catch {
      setErr("Failed to send.");
    } finally {
      setBusy(false);
    }
  };

  if (!providerId || !patientId) return null;

  return (
    <section className="rounded-2xl border bg-white p-4 shadow-sm">
      <h4 className="text-lg font-semibold mb-3">Send Message</h4>
      <form onSubmit={onSend}>
        <textarea
          className="w-full border p-2 rounded"
          rows={2}
          placeholder={`Message patient #${patientId}…`}
          value={content}
          onChange={(e) => setContent(e.target.value)}
          disabled={busy}
        />
        <div className="mt-2 flex items-center gap-3">
          <button
            type="submit"
            className="px-3 py-1 rounded bg-blue-600 text-white disabled:opacity-50"
            disabled={busy || !content.trim()}
          >
            Send
          </button>
          {ok && <span className="text-emerald-600 text-sm">{ok}</span>}
          {err && <span className="text-red-600 text-sm">{err}</span>}
        </div>
      </form>
    </section>
  );
}
